import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivationService } from '@sb-core/services/activation.service';
import { ToastService } from '@sb-core/services/toast.service';

@Component({
    selector: 'app-expired-token',
    templateUrl: './expired-token.component.html',
    styleUrl: './expired-token.component.scss',
    standalone: false
})
export class ExpiredTokenComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private activationService = inject(ActivationService);
  private toastService = inject(ToastService);

  currentYear = new Date().getFullYear();
  email: string = '';
  orgId: string = '';

  ngOnInit() {
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.orgId = this.route.snapshot.queryParamMap.get('oId') ?? '';
  }

  requestNewToken() {
    this.activationService.QueuePasswordResetCommunication(this.orgId, this.email).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.toastService.getSuccess('A new password reset email has been sent. Please check your inbox.', 'Email Sent');
        } else {
          this.toastService.getError('Could not send the password reset email.', 'Error');
        }
      },
      error: (err) => {
        this.toastService.getError('Could not send the password reset email. Please try again.', 'Error');
      }
    });
  }

  backgroundImageUrl(): string {
    return `url(${window.EveryBuddy.WebAPI}/img/backgrounds/3.png)`;
  }
}
